import { post } from '@/utils/request'

/**
 * 淘客查询授权支付宝签约情况:status:1是已签约.0是未签约,(未签约情况下有sign_url,跳转到这个链接去签约)
 */
export default function taoke_check_ali_sign_up(data) {
  return post('taoke_check_ali_sign_up', data)
}